<template>
  <main class="page-operative page-operative-project-library page-operative-project-library-template page-operative-project-library-template-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo modello di progetto (libreria)</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.projects.library.templates.list' }">Torna alla lista</app-router-link>
      </div>

      <FormProjectLibraryTemplate v-if="company && userCanEdit" :libraryCosts="libraryCosts" :libraryImputedCosts="libraryImputedCosts" :personnel="personnel" @saved="saveTemplate" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-project-library-template-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormProjectLibraryTemplate: () => import('@/views/components/Operative/Form/FormProjectLibraryTemplate'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  data () {
    return {
      libraryCosts: [],
      libraryImputedCosts: [],
      personnel: [],
    };
  },
  methods: {
    saveTemplate (template) {
      this.$api.addProjectLibraryTemplate(this.company.id, template)
        .then(() => {
          this.$router.push({
            name: 'operative-company.projects.library.templates.list',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.listProjectLibraryCosts(this.company.id)
          .then(res => {
            this.libraryCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listImputedCosts(this.company.id)
          .then(res => {
            this.libraryImputedCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.getCostiPersonale(this.company.id)
          .then(res => {
            this.personnel = res.data?.costi || [];
          })
          .catch(this.$log.error)
        ;
      },
    },
  },
};

</script>
